module.exports = __webpack_public_path__ + "static/media/refresh-circle.64950fc1.svg";